import { memo } from 'react';
import { isMenu, isTool } from "../guards";
import { ToolbarItem, ToolbarItemType, ToolId } from '../types';
import { READONLY_ENABLED_TOOL_IDS } from '../constants';
import { HoverMenu } from './HoverMenu';
import { ToolButton } from './ToolButton';

type Props = {
  node: ToolbarItem;
  onSelectTool: (toolId: ToolId) => void;
  variant: ToolbarItemType;
  selectedToolId?: ToolId;
  disabled?: boolean;
};

function ToolbarNodeComponent({
  node,
  onSelectTool,
  selectedToolId,
  variant = 'tool',
  disabled = false,
}: Props) {
  if (isTool(node)) {
    const isEnabledInReadonly = READONLY_ENABLED_TOOL_IDS.includes(node.id);
    const isDisabled = disabled && !isEnabledInReadonly;

    return (
      <ToolButton
        tool={node}
        onSelectTool={onSelectTool}
        isSelected={selectedToolId === node.id}
        variant={variant}
        disabled={isDisabled}
      />
    );
  }

  if (isMenu(node)) {
    return (
      <HoverMenu
        menu={node}
        selectedToolId={selectedToolId}
        variant={variant}
        disabled={disabled}
        renderNode={(child) => (
          <ToolbarNode
            node={child}
            onSelectTool={onSelectTool}
            selectedToolId={selectedToolId}
            variant='menu'
            disabled={disabled}
          />
        )}
      />
    );
  }

  return null;
}

export const ToolbarNode = memo(ToolbarNodeComponent);